import useQueryBetRecommendations from '~/components/sportsbook/lobby/queries/bet-recommendations/use-query-bet-recommendations';
import { useMemo } from 'react';
import { StaleTime } from '~/components/sportsbook/lobby/sportsbook-constants';
import { useSelector } from 'react-redux';
import { selectSportsbookBetRecommendationsEnabled } from '~/components/brand/ducks/selectors';

const useBetRecommendations = (recommendationsKey: string, excludedSelectionIds: string[] = []) => {
	const recommendedBetsEnabled = useSelector(selectSportsbookBetRecommendationsEnabled);
	const { data, isLoading } = useQueryBetRecommendations(
		{
			key: recommendationsKey
		},
		{
			staleTime: StaleTime.SHORT,
			refetchOnWindowFocus: false,
			isEnabled: recommendedBetsEnabled
		}
	);

	// Filter the recommended bets
	const filteredRecommendedBets = useMemo(
		() => data?.filter(bet => !bet.items.every(item => excludedSelectionIds.includes(item.selection.id))),
		[data, excludedSelectionIds]
	);

	// Memoize the filtered recommended bets by hashing the selection ids
	// returning a new array reference only when the values has actually changed.
	const filteredRecommendedBetsHash = useMemo(
		() => filteredRecommendedBets?.map(bet => bet.items[0].selection.id).join('') || 'undefined',
		[filteredRecommendedBets]
	);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const memoizedFilteredRecommendedBets = useMemo(() => filteredRecommendedBets, [filteredRecommendedBetsHash]);

	return {
		recommendedBets: memoizedFilteredRecommendedBets || [],
		isLoading
	};
};

export default useBetRecommendations;
